<div class="user-wrapper">
  <div class="hero card-glass mb-3">
    <div class="crumb">
      <a routerLink="/utilisateur/codes" class="crumb-link"><i class="bi bi-arrow-left"></i> Retour au tableau de bord codes</a>
      <span class="crumb-current">Mes transactions</span>
    </div>
    <div class="hero-flex">
      <div>
        <p class="eyebrow">Spay · Tableau de bord</p>
        <h1>Suivre mes opérations</h1>
        <p class="lead">Accédez aux historiques d'achats, dépôts, retraits, transferts et rapports mensuels.</p>
      </div>
    </div>
  </div>

  <div class="row g-3">
    <div class="col-sm-6 col-lg-4">
      <a class="action-card card-glass" routerLink="/utilisateurs/achats">
        <div class="icon-circle"><i class="bi bi-cart-check"></i></div>
        <div>
          <h5>Achats</h5>
          <p>Historique détaillé de vos achats.</p>
        </div>
      </a>
    </div>
    <div class="col-sm-6 col-lg-4">
      <a class="action-card card-glass" routerLink="/utilisateurs/depots">
        <div class="icon-circle"><i class="bi bi-arrow-down-circle"></i></div>
        <div>
          <h5>Dépôts</h5>
          <p>Suivi des dépôts et commissions.</p>
        </div>
      </a>
    </div>
    <div class="col-sm-6 col-lg-4">
      <a class="action-card card-glass" routerLink="/utilisateurs/retraits">
        <div class="icon-circle"><i class="bi bi-arrow-up-circle"></i></div>
        <div>
          <h5>Retraits</h5>
          <p>Vos retraits et justificatifs.</p>
        </div>
      </a>
    </div>
    <div class="col-sm-6 col-lg-4">
      <a class="action-card card-glass" routerLink="/utilisateurs/transferts">
        <div class="icon-circle"><i class="bi bi-arrow-left-right"></i></div>
        <div>
          <h5>Transferts</h5>
          <p>Entrants et sortants effectués.</p>
        </div>
      </a>
    </div>
    <div class="col-sm-6 col-lg-4">
      <a class="action-card card-glass" routerLink="/utilisateurs/mensualites">
        <div class="icon-circle"><i class="bi bi-calendar3"></i></div>
        <div>
          <h5>Rapport mensuel</h5>
          <p>Vue consolidée par mois.</p>
        </div>
      </a>
    </div>
  </div>
</div>
